const defaultState = () => ({
  selected: [],
});

const partiesModule = {
  namespaced: true,
  state: defaultState(),
  mutations: {
    RESET_STATE(state) {
      Object.assign(state, defaultState());
    },
    SET_SELECTED_PARTIES(state, { parties }) {
      state.selected = parties;
    },
  },
  actions: {
    RESET_STATE({ commit }) {
      commit('RESET_STATE');
    },
  },
};

export default partiesModule;
